var _style, _rect, _polygon, _defs, _polygon2, _polygon3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKleverLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "klever",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3366.95 1048",
    style: {
      enableBackground: "new 0 0 3366.95 1048"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{opacity:0.14;clip-path:url(#SVGID_3_);fill:url(#SVGID_4_);enable-background:new    ;}\n\t.st3{fill:url(#SVGID_5_);}\n\t.st4{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "background",
    className: "st0",
    width: 3366.95,
    height: 1048
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 655.5,
    y1: 526,
    x2: 655.5,
    y2: 264,
    gradientTransform: "matrix(1 0 0 -1 0 1050)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.717173e-7,
    style: {
      stopColor: "#FF4681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9B44F6"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "786.5,786 524.5,786 786.5,524  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_2_",
    points: "786.5,786 524.5,786 786.5,524  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -719.248,
    y1: 1989.5168,
    x2: -656.3392,
    y2: 1926.6079,
    gradientTransform: "matrix(0.8685 1.214 0.8089 -0.5787 -265.9847 2674.8735)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 9.430187e-7,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "786.5,786 655.5,655 677.24,633.26 786.5,786  "
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.0118,
    y1: 650.4882,
    x2: 662.0118,
    y2: 126.4882,
    gradientTransform: "matrix(1 0 0 -1 0 1050)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 9.430187e-7,
    style: {
      stopColor: "#FF4681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7392,
    style: {
      stopColor: "#9B44F6"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "786.5,786 262.5,786 262.5,262  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brand_name"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1487.48,261.96h87.43V786h-87.43V261.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2035.31,622.14h-293.03c5.12,27.52,18.54,49.3,40.22,65.4c21.68,16.1,48.6,24.12,80.77,24.12 c41.02,0,74.83-13.53,101.4-40.55l50.22,50.43c-16.79,20.06-41.38,38.63-67.02,48.89s-54.54,15.38-86.71,15.38 c-41.04,0-77.17-8.15-108.39-24.48c-31.24-16.3-55.37-39.04-72.39-68.2c-17.02-29.14-25.54-62.13-25.54-98.96 c0-36.36,8.28-69.12,24.82-98.26c16.54-29.14,39.53-51.87,68.89-68.2c29.37-16.3,62.46-24.48,99.32-24.48 c36.36,0,68.89,8.05,97.57,24.12c28.67,16.1,51.05,38.7,67.14,67.84s24.12,62.82,24.12,101.06 C2036.73,602.34,2036.26,610.95,2035.31,622.14z M1776.89,498.01c-19.36,16.56-31.12,38.57-35.31,66.09h211.9 c-3.73-27.03-15.15-48.96-34.28-65.73c-19.13-16.79-42.89-25.18-71.34-25.18C1819.91,473.16,1796.26,481.44,1776.89,498.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2822.04,622.14h-293.03c5.12,27.52,18.54,49.3,40.22,65.4c21.68,16.1,48.6,24.12,80.77,24.12 c41.02,0,74.83-13.53,101.4-40.55l50.22,50.43c-16.79,20.06-41.38,38.63-67.02,48.89c-25.64,10.26-54.54,15.38-86.71,15.38 c-41.04,0-77.17-8.15-108.39-24.48c-31.25-16.3-55.37-39.04-72.39-68.2c-17.02-29.14-25.54-62.13-25.54-98.96 c0-36.36,8.28-69.12,24.82-98.26c16.54-29.14,39.53-51.87,68.89-68.2c29.37-16.3,62.46-24.48,99.32-24.48 c36.36,0,68.89,8.05,97.57,24.12c28.67,16.1,51.05,38.7,67.14,67.84c16.1,29.14,24.12,62.82,24.12,101.06 C2823.46,602.34,2822.97,610.95,2822.04,622.14z M2563.62,498.01c-19.36,16.56-31.12,38.57-35.31,66.09h211.9 c-3.73-27.03-15.15-48.96-34.28-65.73c-19.13-16.79-42.89-25.18-71.34-25.18C2606.65,473.16,2582.99,481.44,2563.62,498.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2446.15,403.09L2280.46,786h-86.33l-166.46-382.91h90.93l120.07,281.31l123.57-281.31H2446.15z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1306.42,403.09 1414.55,403.09 1177.45,641.17 1122.88,586.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "1123.14,586.37 1176.78,532.7 1429.42,786 1322.28,786 1122.88,586.6 1123.14,586.37  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.48,
    y: 262.22,
    className: "st4",
    width: 87.31,
    height: 523.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M3104.95,403.09v84.4c-7.68-1.42-14.65-2.13-20.88-2.13c-35.04,0-62.4,10.05-82.08,30.14 c-19.69,20.1-29.52,49.06-29.52,86.89v183.7h-90V403.22h85.68v59.45C2994.07,422.95,3039.67,403.09,3104.95,403.09z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKleverLogo);
export default __webpack_public_path__ + "static/media/klever_logo.28e0e25d52c1b928b954e79439d0c988.svg";
export { ForwardRef as ReactComponent };